export const REQUEST_VOICE = 'request-voice';
export const REQUEST = 'request';
export const CALL = 'call';
export const END = 'end';
export const ANSWER = 'answer';
export const CALLING = 'calling';
export const WATCH = 'watch';
export const FUNCTION = 'function';
export const OFFER = 'offer';
export const LOCALSTREAM = 'localStream';
export const PEERSTREAM = 'peerStream';
export const STREAM = 'stream';
export const STREAM_CONFIG = 'stream-config';
export const CHECK_CONNECT_STREAM = 'check-connect-stream';
export const CONNECTION_DISCONNECTED = 'connection-disconnected';
export const LIST_VIDEO_DEVICES = 'list-video-devices';
export const BUSY = 'busy';
export const TIMECALL = 15;
export const TIMECALLRECEIVE = 10;
export const INIT_VIDEO_CALL = 'init-video-call';
export const DECLINE_VIDEO_CALL = 'decline-video-call';
export const TOGGLE_SMALL_VIEW = 'toggle-small-view';
export const SHOW_HIDDEN_DIV = 'show-hidden-div';
export const NOT_ALLOW_ERROR = 'NotAllowedError';
export const NOT_FOUND_ERROR = 'NotFoundError';
export const ABORT_ERROR = 'AbortError';
export const NOT_READ_ABLE_ERROR = 'NotReadableError';
export const OVER_CONSTRAINED_ERROR = 'OverconstrainedError';
export const SECURITY_ERROR = 'SecurityError';
export const VISIBILITY_CHANGE = 'visibilitychange';

export const CALL_STATE_PERMISSION_TYPE = {
  VIDEO: 'video',
  AUDIO: 'audio',
  NONE: 'none',
};
